import selects from "@/utils/selects.js";

export const questions = [
  {
    title: "Your title",
    subtitle: "",
    mainInfo: "",
    key: "title",
    nextOnAnswer: true,
    answer: {
      type: "selects",
      values: [
        {
          text: "Select title",
          items: selects.user.titles,
          value: "",
          nextQuestion: 1,
        },
      ],
    },
  },
  {
    title: "Family or last name as shown in your passport",
    subtitle: "",
    mainInfo: "Family name is the surname that is shared by your family",
    key: "last_name",
    nextOnAnswer: true,
    answer: {
      type: "text",
      values: [
        {
          text: "Enter last name",
          value: "",
          nextQuestion: 2,
        },
      ],
    },
  },
  {
    title: "Given name(s) as shown in your passport",
    subtitle: "",
    mainInfo:
      "Given name is usually the first name. Also can be included in given name: middle names, a suffix (e.g. Jr), a patronymic name",
    key: "first_name",
    nextOnAnswer: true,
    answer: {
      type: "text",
      values: [
        {
          text: "Enter first name",
          value: "",
          nextQuestion: 3,
        },
      ],
    },
  },
  {
    title: "Given name(s) as shown in your passport",
    subtitle: "",
    mainInfo:
      "Given name is usually the first name. Also can be included in given name: middle names, a suffix (e.g. Jr), a patronymic name",
    key: "first_name",
    nextOnAnswer: true,
    answer: {
      type: "text",
      values: [
        {
          text: "Enter name",
          value: "",
          nextQuestion: 4,
        },
      ],
    },
  },
  {
    title: "What is your date of birth?",
    subtitle: "",
    mainInfo: "",
    key: "date_of_birth",
    nextOnAnswer: true,
    answer: {
      type: "text",
      values: [
        {
          text: "date_of_birth",
          value: "",
          nextQuestion: 5,
        },
      ],
    },
  },
  {
    title: "What is your gender?",
    subtitle: "",
    mainInfo: "",
    key: "gender",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: [
        {
          text: "Female",
          value: "Female",
          nextQuestion: 6,
        },
        {
          text: "Male",
          value: "Male",
          info: "",
          nextQuestion: 6,
        },
      ],
    },
  },
  {
    title: "Country of nationality",
    subtitle: "",
    mainInfo: "",
    key: "nationality1",
    nextOnAnswer: true,
    answer: {
      type: "selects",
      values: [
        {
          text: "Select country",
          items: selects.countries,
          value: "",
          nextQuestion: 7,
        },
      ],
    },
  },
  {
    title: "Do you hold any other nationalities?",
    subtitle: "",
    mainInfo: "",
    key: "nationality2_status",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: [
        {
          text: "Yes",
          value: true,
          nextQuestion: 8,
        },
        {
          text: "No",
          value: false,
          info: "",
          nextQuestion: 8,
        },
      ],
    },
  },
  {
    title:
      "Are you currently in the United Kingdom of Great Britain and Northern Ireland?",
    subtitle: "",
    mainInfo: "",
    key: "in_uk_status",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: [
        {
          text: "Yes",
          value: true,
          nextQuestion: 9,
        },
        {
          text: "No",
          value: false,
          info: "",
          nextQuestion: 18,
        },
      ],
    },
  },
  {
    title: "What is your current UK immigration status?",
    subtitle: "",
    mainInfo: "",
    key: "uk_immigration_status",
    nextOnAnswer: true,
    answer: {
      type: "selects",
      values: [
        {
          text: "Select country",
          items: selects.user.immigrationStatus,
          value: "",
          nextQuestion: 7,
        },
      ],
    },
  },
  {
    title: "What is your category?",
    subtitle: "",
    mainInfo: "",
    key: "uk_immigration_category",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: [
        {
          text: "Main applicant",
          value: "Main applicant",
          nextQuestion: 9,
        },
        {
          text: "Dependant",
          value: false,
          info: "Dependant",
          nextQuestion: 18,
        },
      ],
    },
  },

  {
    title: "Select the sector in which your organisation operates",
    subtitle: "",
    mainInfo:
      "Sector that corresponds to your organisation's main economic activity. You can find a breakdown of specific activities that belong to each sector in the 'Summary of Structure' file on the Office for National Statistics website (https://webarchive.nationalarchives.gov.uk/20160105230903/http://www.ons.gov.uk/ons/guide-method/classifications/current-standard-classifications/standard-industrial-classification/index.html)",
    key: "operate_sector",
    nextOnAnswer: true,
    answer: {
      type: "selects",
      values: [
        {
          text: "Select sector",
          items: selects.company.sector,
          value: "",
          nextQuestion: 3,
        },
      ],
    },
  },
  {
    title: "How many employees do you currently employ in the UK?",
    subtitle: "",
    mainInfo:
      "This is the total number of employees working in the UK for the organisation to be licensed at the time of your application, including any migrant workers.",
    key: "number_of_employees",
    nextOnAnswer: true,
    answer: {
      type: "text",
      values: [
        {
          text: "Type number",
          value: "",
          nextQuestion: 4,
        },
      ],
    },
  },
  {
    title: "Is your company listed on the London Stock Exchange Main Market?",
    subtitle: "",
    mainInfo:
      "Approved exchanges are the London Stock Exchange and the FCA/PRA approved stock exchanges. For a list of FCA/PRA approved stock exchanges, please see the The Financial Services Register",
    key: "is_lse_listed",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: [
        {
          text: "Yes",
          value: true,
          nextQuestion: 5,
        },
        {
          text: "No",
          value: false,
          info: "",
          nextQuestion: 5,
        },
      ],
    },
  },
  {
    title:
      "Are you required to be registered with and/or inspected/ monitored by a regulatory body to operate lawfully in the UK?",
    subtitle: "",
    mainInfo: "",
    key: "is_inspected",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: [
        {
          text: "Yes",
          value: true,
          nextQuestion: 6,
        },
        {
          text: "No",
          value: false,
          info: "",
          nextQuestion: 6,
        },
      ],
    },
  },
  {
    title:
      "Have you registered with HM Revenue & Customs (HMRC) as an employer to pay PAYE & National Insurance?",
    subtitle: "",
    mainInfo: "",
    key: "has_paye",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: [
        {
          text: "Yes",
          value: true,
          nextQuestion: 7,
        },
        {
          text: "No",
          value: false,
          info: "",
          nextQuestion: 7,
        },
      ],
    },
  },
  {
    title: "Do you have a VAT registration?",
    subtitle: "",
    mainInfo: "",
    key: "has_vat",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: [
        {
          text: "Yes",
          value: true,
          nextQuestion: 8,
        },
        {
          text: "No",
          value: false,
          info: "",
          nextQuestion: 8,
        },
      ],
    },
  },
  {
    title: "Which one does apply to your business?",
    subtitle: "",
    mainInfo: "",
    key: "business_premises",
    nextOnAnswer: true,
    answer: {
      type: "radio",
      values: selects.company.operates.map((val) => ({
        text: val,
        value: val,
        nextQuestion: 9,
      })),
    },
  },
];
